<template>
    <div class="app bg-gray">
        <section class="thick">
            <hospital-select @selected="selectHospital"></hospital-select>
            <voucher-select :list="voucherList" @selected="selectVoucher"></voucher-select>
        </section>
        <scroll class="from-query" @refresh="refresh">
            <no-record :condition="inpatientInfoList" :tips="'未查到您的住院记录!'"></no-record>
            <div v-if="inpatientInfoList.length > 0">
                <section class="thick">
                    <div class="content charge-list">
                        <span class="f-minor">住院号</span><span class="fr">{{inpatientInfo.inPatientNo}}</span>
                    </div>
                    <div class="content charge-list">
                        <span class="f-minor">院区科室</span><span class="fr">{{inpatientInfo.deptName}}</span>
                    </div>
                    <div class="content charge-list">
                        <span class="f-minor">床位号</span><span class="fr">{{inpatientInfo.bedNo}}</span>
                    </div>
                    <div class="content charge-list">
                        <span class="f-minor">入院时间</span><span class="fr">{{inpatientInfo.inDate}}</span>
                    </div>
                </section>
                <section class="thick">
                    <div class="content charge-list">
                        <span class="f-minor">住院预缴金总额</span><span class="fr f-strongest">{{inpatientInfo.total  | formatFee}}</span>
                    </div>
                    <div class="content charge-list">
                        <span class="f-minor">住院预缴金余额
                            <span class="f-strongest" v-show="inpatientInfo.balance < 0">(余额不足)</span>
                        </span>
                        <span class="fr f-strongest">{{inpatientInfo.balance  | formatFee}}</span>
                    </div>
                </section>
                <div class="chargeIcon-list">
                    <ul>
                        <li class="goRecharge" @click="goRecharge"><div>住院预缴金充值</div></li>
                        <li class="rechargeList" @click="goRechargeList"><div>预缴充值记录</div></li>
                        <li class="costList" @click="goHospitalCostQuery"><div>住院费用查询</div></li>
                    </ul>
                </div>
            </div>
        </scroll>
    </div>
</template>
<script>
    import Confirm from 'Confirm'
    import NoRecord from 'NoRecord'
    import queryFun from 'queryFunList.service'
    import queryVoucher from 'voucher.service'
    import VoucherSelect from 'VoucherSelect'
    import HospitalSelect from 'HospitalSelect'

    export default {
        components: {
            Confirm,
            NoRecord,
            HospitalSelect,
            VoucherSelect
        },
        data() {
            var data = {
                inpatientInfoList: [],
                inpatientInfo: {},
                orderId: '',
                voucher: {},
                voucherList: []
            };
            return data
        },
        created() {
            this.loadVouchers()
        },
        methods: {
            refresh: function () {
                if (!this.voucher.cardType) {
                    return this.$utils.alert('请先绑定诊疗卡')
                }
                //处理初始进入微信的未选医院情况
                if (typeof(http.headers.common['hospitalId']) === "undefined") {
                    this.$utils.alert("请选择医院");
                    return;
                }
                var params = {
                    cardType: this.voucher.cardType,
                    cardNo: this.voucher.cardNo,
                }

                this.loadInPatientInfo(params);
            },
            loadVouchers: function () {
                // 获取用户就诊凭证
                queryVoucher.getVoucherList().then((res) => {
                    if (res.resultCode !== this.constant.RESULT_SUCCESS) {
                        this.$utils.alert(res.resultMsg);
                        return;
                    }

                    const data = res.data;
                    if (data.length === 0) {
                        this.$utils.alert('请先绑定诊疗卡');
                        return;
                    }
                    this.voucherList = data;
                    // 首次进入，默认第一张诊疗卡信息
                    this.voucher = JSON.parse(JSON.stringify(this.voucherList[0]));

                    // 保存默认卡信息
                    this.$store.commit('updateParam', {
                        namespace: 'mypay',
                        voucher: this.voucher,
                    });
                    this.refresh();
                });
            },
            selectHospital: function () {
                this.inpatientInfo = this.constant.JSON_CLEAN;
                this.refresh();
            },
            selectVoucher: function (v) {
                this.inpatientInfo = this.constant.JSON_CLEAN;
                this.voucher = v;

                //保存默认卡信息
                this.$store.commit('updateParam', {
                    namespace: 'mypay',
                    voucher: v
                });
                //加载默认卡的待缴费列表
                this.refresh();
            },
            loadInPatientInfo: function (params) {
                queryFun.getInpatientInfo(params).then((res) => {
                    if (res.resultCode !== this.constant.RESULT_SUCCESS || res.data.length <= 0) {
                        this.inpatientInfoList = [];
                        return;
                    }
                    //防止数组越界
                    this.inpatientInfoList= res.data;
                    this.inpatientInfo = this.inpatientInfoList[0]

                })
            },
            goRechargeList() {
                //区分消息推送和正常页面跳转
                this.$store.commit('updateParam', {
                    namespace: 'myRecharge',
                    queryParam: {
                        inPatientNo: this.inpatientInfo.inPatientNo,
                        cardType: this.voucher.cardType,
                        cardNo: this.voucher.cardNo,
                    }
                })
                this.$router.push('MyRecharge');
            },
            goRecharge() {
                //区分消息推送和正常页面跳转
                this.$store.commit('updateParam', {
                    namespace: 'goRecharge',
                    queryParam: {
                        orgId: http.headers.common['organizationId'],
                        hospitalId: http.headers.common['hospitalId'],
                        inPatientNo: this.inpatientInfo.inPatientNo,
                        cardType: this.voucher.cardType,
                        cardNo: this.voucher.cardNo,
                    }
                })
                this.$router.push('GoRecharge');
            },
            goHospitalCostQuery() {
                //区分消息推送和正常页面跳转
                this.$store.commit('updateParam', {
                    namespace: 'hospitalCostList',
                    queryParam: {
                        inPatientNo: this.inpatientInfo.inPatientNo,
                        cardType: this.voucher.cardType,
                        cardNo: this.voucher.cardNo,
                    }
                })
                this.$router.push('HospitalCostList');
            }
        },
        watch: {
            inpatientInfoList(val) {
                if (val.length === 0) {
                    this.noRecord = true;
                } else {
                    this.noRecord = false;
                }
            }
        }
    }
</script>

<style lang="scss">
    .charge-list {
        border-bottom: 1px solid #e9e9e9;

        .fr {
            float: right;
        }
    }
    .chargeIcon-list {
        ul {
            display: flex;
        }

        li {
            flex: 1;
            height: 4.75rem;
            padding-top: 0.87rem;
            padding-bottom: 0.87rem;
            text-align: center;
            background-color: #fff;
            background-position: center 2.6rem;
            background-repeat: no-repeat;
            background-size: 45px 45px;

            span {
                display: inline-block;
                width: 1px;
                height: 100%;
                background: #eff2f5;
                position: relative;
            }
        }

        .goRecharge {
            background-image: url(../../../static/img/goRecharge.png);
            div {
                height: 100%;
                border-right: 1px solid #eff2f5;
            }
        }

        .rechargeList {
            background-image: url(../../../static/img/rechargeList.png);
            div {
                height: 100%;
                border-right: 1px solid #eff2f5;
            }
        }

        .costList {
            background-image: url(../../../static/img/costList.png);
        }
    }
</style>



// WEBPACK FOOTER //
// InpatientRecharge.vue?3d17ca20